const isLocalhost = window.location.hostname === "localhost";

export const API_BASE_URL = isLocalhost
  ? "http://localhost:5001/bouger-plus-eab63/us-central1/app"
  : "https://us-central1-bouger-plus-eab63.cloudfunctions.net/app";
